import { createAPI } from '@common'
// MediaCloudArticleAuditEdit
export default {
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  postArtcleClassify: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bdujpot0dmbttjgz', 'PUT', config),
  // 自定义审核
  postArticlesAuditOp: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bveju0pq', 'PUT', config),
  // 签发稿件到报纸
  postPaperArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0qbqfst0gpsxbse', 'post', config, {
      timeout: 90000
    }),
  // 签发稿件到全媒体采编发（全媒体采编发提供的接口）
  postArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0jttvf', 'post', config, {
      timeout: 90000
    }),
  // 解锁
  putUnlock: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bdujpot0vompdl', 'PUT', config),
  // 读发布详情
  getRootArticlesPubDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bdujpot0qvcEfubjm', 'get', config),
  // 获取稿件发布设置信息
  getArticlesPubInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0qvcJogp', 'GET', config), // 签发稿件到期刊
  // 撤稿
  postArticlesRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0sfwplf', 'post', config),
  // 审核
  postRootArticlesPass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0sppuBsujdmft0qbtt', 'post', config),
  // 驳回
  postRootArticlesReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0sppuBsujdmft0sfkfdu', 'post', config),
  // 移动
  postRootArticlesMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bdujpot0npwf', 'post', config),
  // 删除
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bdujpot0efmfuf', 'DELETE', config),
  // 读当前用户的所属部门文件夹列表，以及用户的缺省部门库(全媒体采编发的接口)
  postNewseditUsersFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0ofxtfeju0vtfst0gpmefst', 'get', config),
  // 将一到多篇稿件送到采编系统的部门库，并且把稿件的“当前处理人”设置为当前用户(全媒体采编发的接口)
  postNewseditArticlesSelect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0ofxtfeju0bsujdmft0tfmfdu', 'post', config),
  // 读当前用户有“可传入数据权限”的部门库内的文件夹列表(全媒体采编发的接口)
  getNewseditFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0ofxtfeju0gpmefst', 'get', config),
  // 读一个文件夹下的所有用户列表(全媒体采编发的接口)
  getNewseditFoldersUsers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0ofxtfeju0gpmefst0vtfst', 'get', config),
  // 指定一到多个文件夹，以及文件夹指定一到多个用户（可以不指定），把一到多篇稿件送入(全媒体采编发的接口)
  postNewseditArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0ofxtfeju0bsujdmft0usbotgfs',
      'post',
      config
    ),
  // 选用初始化
  getNewseditSelectInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0ofxtfeju0tfmfdu0joju', 'get', config),
  getForwardLogs: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0nfejby.bsujdmfbveju0sppuBsujdmft0gpsxbse0mpht',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub', ...vconfig }
      )
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0sppuBsujdmft0gpsxbse0mpht',
        'get',
        { params: config.params },
        vconfig
      )
    }
  },
  // 送审
  postRootArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0sppuBsujdmft0usbotgfs', 'post', config),
  getRootFolderRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs0sppu', 'get', config),
  //树节点
  getRootArticlesTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0f60gpmefst', 'get', config),
  // 获取联级树节点
  getRootConfigTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0dpogjh0usff', 'get', config),
  postArticleProof: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0sppuBsujdmft0qsppg', 'post', config),

  // 送稿-树
  getDeptSendTree: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0tfoe0usff',
      'get',
      config,
      vconfig
    ),
  // 选用文件夹树-部门树
  getDeptTree: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0ublf0usff',
      'get',
      config,
      vconfig
    ),
  // 选用-保存
  postArticleSelect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0sppuBsujdmft0tfmfdu', 'post', config),
  // 获取人员信息
  getUsersOfDept: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsgpmefs0vtfst', 'get', config, vconfig),
  // 送稿-保存
  postArticleSend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0sppuBsujdmft0tfoe', 'post', config),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0efubjm', 'get', config, {
      timeout: 90000
    }),
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0efubjm', 'get', config, {
      timeout: 90000
    }),
  // 重新送审
  postReAudit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bdujpot0sfBveju', 'POST', config),
  // 写稿初始化
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0joju', 'get', config),
  // 写稿保存
  postSave: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0tbwf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0f60bdujpot0efubjmbdujpot', 'get', config),
  // 流程记录
  getE5ActionsLogs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0f60bdujpot0mpht', 'get', config, vconfig),
  // 查看权限 待办
  getAssignStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0bttjho0tubuvt', 'get', config),
  // 查看权限消息
  getDetailStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0efubjm0tubuvt', 'get', config),
  // 审稿库签发到畅享全媒体稿源稿库接口
  signRemoteRootForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0ofxtfeju0tjho0sppu0gpxbse',
      'post',
      config,
      {
        timeout: 90000
      }
    ),
  // 审稿库签发到畅享全媒体部门库接口
  signRemoteEditForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0ofxtfeju0tjho0feju0gpxbse',
      'post',
      config,
      {
        timeout: 90000
      }
    ),
  // 新-稿件预览
  postNewPreview: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0bqqQsfWjfx', 'post', config),

  // 为打印功能定制的 批量查询稿件信息接口
  postArticlePrint: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bdujpot0qsjou', 'post', config),

  // 判断是否有回收站权限
  getRecycleRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0hfuSfdzdmf', 'get', config),
  // 还原已删除稿件
  postArticleRevert: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bdujpot0bsujdmfSfwfsu',
      'post',
      config,
      vconfig
    ),
  // 彻底删除已删除稿件
  postArticleDeleteReal: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bdujpot0efmfufSfbm',
      'post',
      config,
      vconfig
    ),
  // 归档
  postArticlePOF: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bdujpot0bsujdmfQPG', 'POST', config),
  // 重复归档提示
  postCheckPOF: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bdujpot0difdlQPG', 'POST', config), // 获取稿件发布设置信息

  // 签发稿件到期刊
  postJournalArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0kpvsobm0gpsxbse', 'post', config, {
      timeout: 90000
    }),
  // 小样重稿-获取文章相似稿列表
  getSimilarList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0tjnjmbs0mjtuebub', 'get', config),
  // 小样重稿-获取文章相似稿详情
  getSimilarDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0tjnjmbs0efubjm', 'get', config)
}
